"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectActiveSiteId = exports.getIsSingleSite = exports.getFiltersByFormName = exports.getFilteredDataById = exports.getFilteredData = exports.getDataSitesLength = exports.getDataSiteValuesByID = exports.getDataSiteById = exports.getDataSite = void 0;
var _constants = require("../../utils/constants");
const getDataSiteValuesByID = _ref => {
  let {
    [_constants.packageKey]: {
      sites
    } = {}
  } = _ref;
  return Object.values((sites === null || sites === void 0 ? void 0 : sites.byId) || {});
};
exports.getDataSiteValuesByID = getDataSiteValuesByID;
const getDataSitesLength = _ref2 => {
  let {
    [_constants.packageKey]: {
      sites
    } = {}
  } = _ref2;
  return Object.keys((sites === null || sites === void 0 ? void 0 : sites.byId) || {}).length;
};
exports.getDataSitesLength = getDataSitesLength;
const getDataSiteById = id => _ref3 => {
  var _sites$byId;
  let {
    [_constants.packageKey]: {
      sites
    } = {}
  } = _ref3;
  return (sites === null || sites === void 0 ? void 0 : (_sites$byId = sites.byId) === null || _sites$byId === void 0 ? void 0 : _sites$byId[id]) || null;
};
exports.getDataSiteById = getDataSiteById;
const getDataSite = _ref4 => {
  let {
    [_constants.packageKey]: {
      sites
    } = {}
  } = _ref4;
  return (sites === null || sites === void 0 ? void 0 : sites.byId[sites.active]) || {};
};
exports.getDataSite = getDataSite;
const selectActiveSiteId = _ref5 => {
  let {
    [_constants.packageKey]: {
      sites
    } = {}
  } = _ref5;
  return (sites === null || sites === void 0 ? void 0 : sites.active) || null;
};
exports.selectActiveSiteId = selectActiveSiteId;
const getFiltersByFormName = nameForm => _ref6 => {
  let {
    [_constants.packageKey]: {
      sites
    } = {}
  } = _ref6;
  return ((sites === null || sites === void 0 ? void 0 : sites.filters.activeFilters) || {})[nameForm];
};
exports.getFiltersByFormName = getFiltersByFormName;
const getFilteredData = _ref7 => {
  let {
    [_constants.packageKey]: {
      sites
    } = {}
  } = _ref7;
  return (sites === null || sites === void 0 ? void 0 : sites.filters.data) || {};
};
exports.getFilteredData = getFilteredData;
const getFilteredDataById = formId => _ref8 => {
  let {
    [_constants.packageKey]: {
      sites
    } = {}
  } = _ref8;
  return ((sites === null || sites === void 0 ? void 0 : sites.filters.data) || {})[formId];
};
exports.getFilteredDataById = getFilteredDataById;
const getIsSingleSite = _ref9 => {
  let {
    [_constants.packageKey]: {
      sites
    } = {}
  } = _ref9;
  return (sites === null || sites === void 0 ? void 0 : sites.isSingleSite) || false;
};
exports.getIsSingleSite = getIsSingleSite;